module.exports = __webpack_public_path__ + "static/network-stats-264c9cbbd07ad2b14889bb5d1085e78b.png";